export const SECTION_BROWSER_PUSH_NOTIFICATION = 5001;